import {ChangeDetectionStrategy, Component, input} from '@angular/core';

@Component({
    selector: 'app-badge-pill',
    standalone: true,
    template: `
        <span class="badge border bg-transparent" [class]="colorClass()">{{ label() }}</span>
    `,
    styles: `
        :host {
            display: inline-block;
            font-size: 1.15rem;
        }

        .badge {
            border-color: currentColor;
            letter-spacing: 0.04em;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgePillComponent {
    readonly label = input.required<string>();
    readonly colorClass = input.required<string>();
}
